import React from 'react';

export const fabricsButtonHref = '/catalogue/oformlenie-okna';
export const texts = {
	modals: {
		fabrics: {
			title: '2 000 различных тканей и цветов',
			contentItems: [
				'В нашем магазине представлен огромный выбор тканей разных видов и расцветок.',
				'Мы предлагаем высококачественные материалы для пошива штор, покрывал, подушек и наволочек, чехлов для мебели и других текстильных изделий из тканей блэкаут, искусственной кожи, мебельной ткани, оксфорда, рогожки, гобелена, велюра, бархата и других.',
				'Ассортимент включает в себя почти 2000 различных тканей для разных использований – от тюля и штор, до мебели и декора.',
			],
			button: 'Открыть каталог',
		},
		time: {
			title: 'Срок изготовления от 3 до 14 дней',
			contentItems: [
				'Срок зависит от сложности изготовления. Сложные проекты исполняются от 3 до 14 дней.',
				'Экспресс пошив (проверяйте доступность услуги в вашем магазине) может быть выполнен в тот же день.',
			],
			button: 'Отлично',
		},
		sewing: {
			title: 'Пошив и установка штор',
			contentItems: [
				'Пошьем проекты любой сложности для любого окна, доставим и развесим готовые изделия у вас на объекте.',
				'Так же в магазине доступны услуги Экспресс пошива, если вам не терпится оформить ваше окно уже сегодня!',
			],
			button: 'Посмотреть услуги',
		},
		delivery: {
			title: 'Доставка',
			contentItems: [
				'Воспользуйтесь удобной доставкой штор и их монтажа в оконном пространстве. Мы предлагаем качественные рулонные шторы, жалюзи и плиссе различных видов и материалов.',
				'Наши специалисты привезут шторы в удобное время и произведут монтаж изделий прямо к вам домой или в офис.',
			],
			button: 'Посмотреть услуги',
		},
	},
	attributes: {
		fabrics: {
			title: '2 000 тканей\nи\u00A0цветов',
		},
		time: {
			title: 'Срок изготовления от\u00A03\u00A0до\u00A014\u00A0дней',
		},
		sewing: {
			title: 'Пошив\nи\u00A0установка штор',
		},
		delivery: {
			title: 'Доставка',
		},
	},
};
